import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './modules/main/main.component';
import { LoginComponent } from './modules/login/login.component';
import { NonAuthGuard } from './guards/non-auth.guard';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from './modules/recover-password/recover-password.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { DirtyFormGuard } from './services/dirty-check.service';
import { VerificationCodeComponent } from './modules/verification-code/verification-code.component';
import { CollegeAddEditComponent } from './pages/College-list/college-add-edit/college-add-edit.component'; 
import { CollegeListComponent } from './pages/College-list/college-list.component'; 
import { CollegeBatchListComponent } from './pages/college-batch-list/college-batch-list.component';
import { CollegeBatchAddEditComponent } from './pages/college-batch-list/college-batch-add-edit/college-batch-add-edit.component';
import { CollegeViewComponent } from './pages/College-list/college-view/college-view.component';
import { CollegeBatchViewComponent } from './pages/college-batch-list/college-batch-view/college-batch-view.component'; 
import { StudentComponent } from './pages/student/student.component';
import { QuestionSetComponent } from './pages/question-set/question-set.component';
import { QuestionSetAddEditComponent } from './pages/question-set/question-set-add-edit/question-set-add-edit.component';
import { QuestionSetViewComponent } from './pages/question-set/question-set-view/question-set-view.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { TestComponent } from './pages/test/test.component';
import { TestAddEditComponent } from './pages/test/test-add-edit/test-add-edit.component';
import { UserListComponent } from './pages/user-list/user-list.component';
import { UserAddEditComponent } from './pages/user-list/user-add-edit/user-add-edit.component';
import { UserViewComponent } from './pages/user-list/user-view/user-view.component';
import { ReportProblemComponent } from './pages/report-problem/report-problem.component';
import { ReportProblemViewComponent } from './pages/report-problem/report-problem-view/report-problem-view.component';
import { QuestionListComponent } from './pages/questions/question-list/question-list.component';
import { QuestionEditComponent } from './pages/questions/question-edit/question-edit.component';
import { QuestionViewComponent } from './pages/questions/question-view/question-view.component';
import { QuestionAddComponent } from './pages/questions/question-add/question-add.component';
import { CompanyListComponent } from './pages/company-list/company-list.component';
import { CompanyAddEditComponent } from './pages/company-list/company-add-edit/company-add-edit.component';
import { CompanyViewComponent } from './pages/company-list/company-view/company-view.component';
import { DisplayProfileComponent } from './pages/display-profile/display-profile.component';
import { AdminType } from './enum/question-enum';
import { AuthGuard } from './guards/auth.guard';
import { CompanyUserComponent } from './pages/company-user/company-user.component';
import { CompanyUserAddEditComponent } from './pages/company-user/company-user-add-edit/company-user-add-edit.component';
import { TestStudentViewComponent } from './pages/test/test-student-view/test-student-view.component';
import { TestDetailComponent } from './pages/test/test-detail/test-detail.component';
import { StudentResultComponent } from './pages/test/student-result/student-result.component';
import { StudentAddComponent } from './pages/student/student-add/student-add.component';
import { RestartExamComponent } from './pages/restart-exam-dialogbox/restart-exam/restart-exam.component';
import { JobComponent } from './pages/job/job.component';
import { AddJobComponent } from './pages/job/add-job/add-job.component';
import { JobTypeComponent } from './pages/job/job-type/job-type.component';
import { CompanyProfileComponent } from './pages/company-profile/company-profile/company-profile.component';
import { ParentTechnologyPreferenceComponent } from './pages/Technology-Preference/parent-technology-preference/parent-technology-preference.component';
import { AddParentTechnologyPreferenceComponent } from './pages/Technology-Preference/add-parent-technology-preference/add-parent-technology-preference.component';
import { ChildTechnologyPreferenceComponent } from './pages/Technology-Preference/child-technology-preference/child-technology-preference.component';
import { AddChildTechnologyPreferenceComponent } from './pages/Technology-Preference/add-child-technology-preference/add-child-technology-preference.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Login'
    },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Forgot Password'
    },
  },
  {
    path: 'recover-password/:',
    component: RecoverPasswordComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Recover Password'
    },
  },
  {
    path: 'verification-code/:',
    component: VerificationCodeComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Verification Code'
    },
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canDeactivate: [DirtyFormGuard],
        data: {
          title: 'Change password'
        },
      },
      {
        path: 'college',
        component: CollegeListComponent,
        data: {
          title: 'College',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college/edit/:id',
        component: CollegeAddEditComponent,
        data: {
          title: 'Collage Edit',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college/add',
        component: CollegeAddEditComponent,
        data: {
          title: 'Collage Add',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college-batch',
        component: CollegeBatchListComponent,
        data: {
          title: 'College Batch',
          role:[AdminType.CompanyAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college-batch/add',
        component: CollegeBatchAddEditComponent,
        data: {
          title: 'Collage Batch Add',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college-batch/edit/:id',
        component: CollegeBatchAddEditComponent,
        data: {
          title: 'College Batch Edit',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college/view/:id',
        component: CollegeViewComponent,
        data: {
          title: 'College View',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'college-batch/view/:id',
        component: CollegeBatchViewComponent,
        data: {
          title: 'College Batch View',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'student',
        component: StudentComponent,
        data: {
          title: 'Students',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'job',
        component: JobComponent,
        data: {
          title: 'Job',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'job/add',
        component: AddJobComponent,
        canDeactivate: [DirtyFormGuard],
        data: {
          title: 'Add Job',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'job/edit/:id',
        component: AddJobComponent,
        canDeactivate: [DirtyFormGuard],
        data: {
          title: 'Edit Job',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'job/applied-job/:id/:title',
        component: JobTypeComponent,
        data: {
          title: 'Job',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'student/add',
        component: StudentAddComponent,
        data: {
          title: 'Student Add',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'student/edit/:id',
        component: StudentAddComponent,
        data: {
          title: 'Student Edit',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question-set',
        component: QuestionSetComponent,
        data: {
          title: 'Question Set',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question-set/add',
        component: QuestionSetAddEditComponent,
        data: {
          title: 'Add Question Set',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question-set/edit/:id',
        component: QuestionSetAddEditComponent,
        data: {
          title: 'Edit Question Set',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question-set/view/:id',
        component: QuestionSetViewComponent,
        data: {
          title: 'View Question Set',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-profile',
        component: EditProfileComponent,
        data: {
          title: 'Edit Profile'
        },
      },
      {
        path: 'exam',
        component: TestComponent,
        data: {
          title: 'Exam',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path:'exam/edit/:id',
        component: TestAddEditComponent,
        data:{
          title: 'Exam Edit',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },  
      {
        path: 'exam/add',
        component: TestAddEditComponent,
        data: {
          title: 'Exam Add',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'exam/studentlist/:id',
        component: TestStudentViewComponent,
        data: {
          title: 'Exam Student List',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'exam/examdetail/:id',
        component: TestDetailComponent,
        data: {
          title: 'exam Detail',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'exam/studentresult/:id',
        component: StudentResultComponent,
        data: {
          title: 'Exam Student Result',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'user',
        component: UserListComponent,
        data: {
          title: 'User' ,
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'user/add',
        component: UserAddEditComponent,
        data: {
          title: 'Add User',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'user/edit/:id',
        component: UserAddEditComponent,
        data: {
          title: 'Edit User',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'user/view/:id',
        component: UserViewComponent,
        data: {
          title: 'User View',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'report-problem',
        component: ReportProblemComponent,
        data: {
          title: 'Report Problem',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'report-problem/view/:id',
        component: ReportProblemViewComponent,
        data: {
          title: 'Report Problem View',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question',
        component: QuestionListComponent,
        data: {
          title: 'Question',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question/edit/:type/:id',
        component: QuestionEditComponent,
        canDeactivate: [DirtyFormGuard],
        data: {
          title: 'Question Edit',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question/add',
        component: QuestionAddComponent,
        canDeactivate: [DirtyFormGuard],
        data: {
          title: 'Question Add',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'question/view/:type/:id',
        component: QuestionViewComponent,
        data: {
          title: 'Question View',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'company',
        component: CompanyListComponent,
        data: {
          title: 'Company',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'company/add',
        component: CompanyAddEditComponent,
        data: {
          title: 'Add Company',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'company/edit/:id',
        component: CompanyAddEditComponent,
        data: {
          title: 'Edit Company',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'company/view/:id',
        component: CompanyViewComponent,
        data: {
          title: 'Company View',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        component: DisplayProfileComponent,
        data: {
          title: 'Profile'
        },
      },
      {
        path: 'company-user',
        component: CompanyUserComponent,
        data: {
          title: 'Company User' ,
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'company-profile',
        component: CompanyProfileComponent,
        data: {
          title: 'Company Profile',
          role:[AdminType.CompanyAdmin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'Parent-technology-preference',
        component: ParentTechnologyPreferenceComponent,
        data: {
          title: 'Parent Technology Preference',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'Parent-technology-preference/add',
        component: AddParentTechnologyPreferenceComponent,
        data: {
          title: 'Parent Technology Preference Add',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'Child-technology-preference',
        component: ChildTechnologyPreferenceComponent,
        data: {
          title: 'Child Technology Preference',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'Child-technology-preference/add',
        component: AddChildTechnologyPreferenceComponent,
        data: {
          title: 'Child Technology Preference Add',
          role:[AdminType.SuperAdmin,AdminType.HR,AdminType.Receptionist,AdminType.Admin]
        },
        canActivate: [AuthGuard],
      }
    ]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Unauthorized'
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [NonAuthGuard],
    data: {
      title: 'Page not found'
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [DirtyFormGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
